module.exports = __webpack_public_path__ + "images/application/templates/layout-basic-full-0e9c0198.png";